import { createAsyncThunk } from "@reduxjs/toolkit"
import {
  del,
  formDataPost,
  formDataPut,
  patch,
  post,
  put,
} from "helpers/api_helper"
import {
  ADD_BRANCH,
  CLONE_BRANCH,
  COPY_BRANCH_SETTINGS,
  DELETE_BRANCH,
  GENERATE_BRANCH_ID,
  GET_ALL_BRANCHES_LIST,
  GET_BRANCH_DETAILS,
  UPDATE_BRANCH,
  UPDATE_BRANCH_STATUS,
  UPDATE_MULTIPLES_BRANCH,
} from "helpers/url_helper"

export const getAllBranchsList = createAsyncThunk(
  GET_ALL_BRANCHES_LIST,
  async payload => {
    const response = await post(GET_ALL_BRANCHES_LIST, payload)
    return response
  }
)

export const updateBranchStatus = createAsyncThunk(
  UPDATE_BRANCH_STATUS,
  async payload => {
    const response = await patch(UPDATE_BRANCH_STATUS, payload)
    return response
  }
)

export const addNewBranch = createAsyncThunk(ADD_BRANCH, async payload => {
  const response = await formDataPost(ADD_BRANCH, payload)
  return response
})

export const deleteBranch = createAsyncThunk(DELETE_BRANCH, async payload => {
  const response = await del(DELETE_BRANCH, payload)
  return response
})

export const getBranchDetails = createAsyncThunk(
  GET_BRANCH_DETAILS,
  async payload => {
    const response = await post(GET_BRANCH_DETAILS, payload)
    return response
  }
)

export const updateBranch = createAsyncThunk(UPDATE_BRANCH, async payload => {
  const response = await formDataPut(UPDATE_BRANCH, payload)
  return response
})

export const updateMultiplesBranch = createAsyncThunk(
  UPDATE_MULTIPLES_BRANCH,
  async payload => {
    const response = await put(UPDATE_MULTIPLES_BRANCH, payload)
    return response
  }
)

export const copyBranchSettings = createAsyncThunk(
  COPY_BRANCH_SETTINGS,
  async payload => {
    const response = await post(COPY_BRANCH_SETTINGS, payload)
    return response
  }
)

export const cloneBranch = createAsyncThunk(
  CLONE_BRANCH,
  async payload => {
    const response = await post(CLONE_BRANCH, payload)
    return response
  }
)
